import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {Constants} from "../../util/constants";
import {BackendUser, BackendUserService} from "../../services/backend-user.service";
import {finalize} from "rxjs/operators";
import {UtilService} from "../../services/util.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {StateService} from "../../services/state.service";
import {Router} from "@angular/router";
import {MatTableDataSource} from "@angular/material/table";
import {timer} from "rxjs";

@Component({
    templateUrl: './backend-users.component.html',
    styleUrls: ['./backend-users.component.css']
})
export class BackendUsersComponent implements OnInit, AfterViewInit {

    readonly columnsToDisplay = ['email', 'type', 'created', 'updated'];
    readonly INITIAL_PAGE_INDEX = 0;
    readonly INITIAL_PAGE_SIZE = Constants.DEFAULT_PAGE_SIZE;

    @ViewChild('paginator') paginator: MatPaginator;
    initializing: boolean = false;
    private users: BackendUser[] = [];
    dataSource: MatTableDataSource<BackendUser>;
    filter: string;
    showDisabled: boolean = false;

    constructor(private backendUserService: BackendUserService,
                private state: StateService,
                private router: Router,
                private cdRef: ChangeDetectorRef,
                private utilService: UtilService) {
        this.showDisabled = !!this.state.get("backendShowDisabled");
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.initializing = true;
        this.cdRef.detectChanges();
        this.backendUserService.getAll().pipe(
            finalize(() => {
                this.initializing = false
                this.cdRef.detectChanges();
            })
        ).subscribe((out) => {
            this.users = out;
            this.dataSource = new MatTableDataSource<BackendUser>(this.visibleUsers);
            timer().subscribe(() => {
                this.dataSource.paginator = this.paginator;
            })
        }, this.utilService.getErrorHandler("Error retrieving back-end users"));
    }

    disabledChanged() {
        this.dataSource = new MatTableDataSource<BackendUser>(this.visibleUsers);
        this.dataSource.paginator = this.paginator;
        this.dataSource.filter = this.filter;
        this.state.set("backendShowDisabled", this.showDisabled);
    }

    get visibleUsers(): BackendUser[] {
        return this.showDisabled? this.users : this.users.filter((u) => !u.disabled);
    }

    applyFilter(ev) {
        this.dataSource.filter = this.filter;
        this.dataSource.paginator?.firstPage();
    }

    clearFilter() {
        this.filter = undefined;
        this.applyFilter(null);
    }

    pageChanged(ev: PageEvent) {
        // this.updateUserRange();
    }

    showUser(user: BackendUser) {
        this.state.set("currentBackendUser", user);
        this.router.navigateByUrl('/backend-user').then();
    }

}
